<template>
  <Wrapper>
    <Dashboard>
      <Overview />
    </Dashboard>
  </Wrapper>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useDashboardData } from '@/composables/use-dashboard-data.ts'
import Overview from '@/components/dashboard/Overview.vue'
import Dashboard from '@/components/wrappers/Dashboard.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  name: 'dashboard',
  meta: {
    titleKey: 'tab.dashboard',
    requiresAuth: true,
  },
})

const { fetchDashboardData } = useDashboardData()

onMounted(() => {
  fetchDashboardData()
})
</script>
